import { motion } from "framer-motion";

const PulsingIndicator = ({ size = 8, color = "currentColor", className = "" }) => {
  return (
    <motion.div
      className={`rounded-full ${className}`}
      style={{
        width: size,
        height: size,
        backgroundColor: color,
      }}
      animate={{ 
        scale: [1, 1.3, 1], 
        opacity: [0.6, 0.9, 0.6] 
      }}
      transition={{ 
        duration: 2, 
        repeat: Infinity, 
        ease: "easeInOut" 
      }}
    />
  );
};

export default PulsingIndicator;

